export const cardDetailsInfo = {
  freePlan: [
    { text: "Ver recetas de otros Quickers", isIncluded: true },
    {
      text: "Agregar recetas de otros Quickers a tu sección de Favoritos",
      isIncluded: true,
    },
    {
      text: "Crear tus propias recetas solamente de tipo free",
      isIncluded: true,
    },
    {
      text: "Agregar recetas tipo premium de otros Quickers a tu sección de Favoritos",
      isIncluded: false,
    },
  ],
  premiumPlan: [
    { text: "Ver recetas de otros Quickers", isIncluded: true },
    {
      text: "Agregar recetas de otros Quickers a tu sección de Favoritos",
      isIncluded: true,
    },
    { text: "Crear tus propias recetas", isIncluded: true },
    { text: "Crear tus propias recetas tipo Free o Premium", isIncluded: true },
    {
      text: "Agregar recetas tipo premium de otros Quickers a tu sección de Favoritos",
      isIncluded: true,
    },
  ],
};
